import { Linking } from 'react-native'

export const visitSupportCenter = () => {
  Linking.openURL('https://playershealth.happyfox.com/home/').catch((err) =>
    console.error(`Can't open the link!`, err)
  )
}
